import React, { useState, useEffect } from "react";
import { api_get, api_post } from "../../helpers/index";
import AddSpinAcquisition from "../../core/modals/spin/addspinacquisition";
import Swal from "sweetalert2";

const TokenConfig = () => {
  const [tokenAcquisitionDepositAmount, setTokenAcquisitionDepositAmount] = useState("");
  const [tokenAcquisitionAmount, setTokenAcquisitionAmount] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchTokenConfig();
  }, []);

  const fetchTokenConfig = async () => {
    try {
      const response = await api_get("token/config");
      if (response.status === 1 && response.data) {
        setTokenAcquisitionDepositAmount(response.data.token_acquisition_deposit_amount);
        setTokenAcquisitionAmount(response.data.token_acquisition_amount);
      } else {
        console.error("Failed to fetch token configuration");
      }
    } catch (error) {
      console.error("Error fetching token configuration:", error);
    }
  };

  const handleUpdateConfig = async () => {
    const newErrors = {};
    if (!tokenAcquisitionDepositAmount) newErrors.tokenAcquisitionDepositAmount = "Token Acquisition Deposit Amount is required.";
    if (!tokenAcquisitionAmount) newErrors.tokenAcquisitionAmount = "Token Acquisition Amount is required.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    const body = {
      token_acquisition_deposit_amount: Number(tokenAcquisitionDepositAmount),
      token_acquisition_amount: Number(tokenAcquisitionAmount),
    };

    try {
      const response = await api_post("token/update_config", body);
      if (response.status === 1) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Token configuration updated successfully!"
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update token configuration. Please try again later."
        });
      }
    } catch (error) {
      console.error("Error updating token configuration:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while updating the token configuration. Please try again later."
      });
    }
  };

  const handleRetrieveAcquisitionList = async (keyword = "") => {
    try {
      const response = await api_get(`spinwheel/token/acquisition/list?keyword=${keyword}`);
      if (response.status === 1) {
        setAcquisitionList(response.data);
      } else {
        console.error("Failed to fetch acquisition list");
      }
    } catch (error) {
      console.error("Error fetching acquisition list:", error);
    }
  };

  return (
    <div className="page-wrapper cardhead">
      <div className="content container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header justify-content-between">
                <div className="card-title">Token Acquisition Configuration</div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Token Acquisition Deposit Amount (AUD)</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter deposit amount in AUD"
                      value={tokenAcquisitionDepositAmount}
                      onChange={(e) => setTokenAcquisitionDepositAmount(e.target.value)}
                    />
                    {errors.tokenAcquisitionDepositAmount && (
                      <div className="text-danger mt-1">{errors.tokenAcquisitionDepositAmount}</div>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Token Acquisition Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter number of tokens"
                      value={tokenAcquisitionAmount}
                      onChange={(e) => setTokenAcquisitionAmount(e.target.value)}
                    />
                    {errors.tokenAcquisitionAmount && (
                      <div className="text-danger mt-1">{errors.tokenAcquisitionAmount}</div>
                    )}
                  </div>
                  <div className="col-md-12">
                    <button type="button" className="btn btn-primary" onClick={handleUpdateConfig}>
                      Update Configuration
                    </button>
                  </div>
                  <div className="col-md-12 mt-3">
                    <div className="alert alert-info">
                      <strong>How it works:</strong>
                      <br />
                      If you set Token Acquisition Deposit Amount to 30 AUD and Token Acquisition Amount to 1 token:
                      <br />
                      • A user depositing 100 AUD will receive 3 tokens (100 ÷ 30 = 3.33, rounded down to 3)
                      <br />
                      • Multiple deposits on the same day are combined for token calculation
                      <br />
                      • Token calculation is based on daily deposit totals
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddSpinAcquisition onSuccess={handleRetrieveAcquisitionList} />
    </div>
  );
};

export default TokenConfig;